import styled from '@emotion/styled'

import { RemoteFeatureFlagStatus } from './enums/remoteFeatureFlagStatus'

interface StatusColors {
  background: string
  dot: string
}

const statusColors: Record<RemoteFeatureFlagStatus, StatusColors> = {
  [RemoteFeatureFlagStatus.True]: {
    background: 'var(--lumen-color-surface-success-subtle-default)',
    dot: 'var(--lumen-color-surface-success-bold-default)',
  },
  [RemoteFeatureFlagStatus.False]: {
    background: 'var(--lumen-color-surface-danger-subtle-default)',
    dot: 'var(--lumen-color-surface-danger-bold-default)',
  },
  [RemoteFeatureFlagStatus.NotFound]: {
    background: 'var(--lumen-color-surface-neutral-subtle-default)',
    dot: 'var(--lumen-color-surface-neutral-medium-default)',
  },
  [RemoteFeatureFlagStatus.Error]: {
    background: 'var(--lumen-color-surface-warning-subtle-default)',
    dot: 'var(--lumen-color-surface-warning-bold-default)',
  },
  [RemoteFeatureFlagStatus.Value]: {
    background: 'transparent',
    dot: 'var(--lumen-color-surface-accent-bold-default)',
  },
}

interface StatusProps {
  $status: RemoteFeatureFlagStatus
}

export const AccordionHeader = styled.button<StatusProps>`
  display: grid;
  align-items: center;
  gap: var(--lumen-spacing-12);
  grid-template-columns: auto 1fr auto auto;
  padding: var(--lumen-padding-12) var(--lumen-padding-16);
  border: none;
  border-radius: var(--lumen-border-radius-16);
  background-color: ${({ $status }) => statusColors[$status].background};
  text-align: left;
  cursor: pointer;

  &[aria-expanded='true'] {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  code {
    font-family: monospace;
    overflow-wrap: anywhere;
  }
`

export const StatusDot = styled.span<StatusProps>`
  width: 10px;
  height: 10px;
  border-radius: var(--lumen-border-radius-full);
  background-color: ${({ $status }) => statusColors[$status].dot};
`
